import { withImageType } from '@krp/ui-kit'

import { searchRun } from '../model/searchRun'

/**
 * Готовит снимок к поиску. Кадр НЕ перекодируется и не уменьшается: качество решает служба `media`. Единственное, что делает клиент, —
 * называет тип содержимого, если браузер его не назвал (HEIC в Chrome на Windows), потому что сервер требует `image/*`.
 */
export async function preparePhoto(file: File): Promise<File> {
  searchRun.beginPrepare('file', file.name, file.size)
  const prepared = withImageType(file)
  searchRun.endPrepare({ toBytes: prepared.size })
  return prepared
}

/** Кадр, снятый камерой сканера: уже PNG без потерь, перекодировать нечего - шаг так и показывается. */
export async function prepareCameraFrame<T extends Blob>(grab: () => Promise<T | null>): Promise<T | null> {
  searchRun.beginPrepare('camera', 'scan.png', null)
  const frame = await grab()
  searchRun.endPrepare({ toBytes: frame?.size ?? 0 })
  return frame
}
